import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  box-shadow: 0px ${pxToRem(4)} ${pxToRem(10)} rgba(0, 0, 0, 0.1);
  border-radius: ${pxToRem(20)};
  background: rgb(255, 255, 255);
  padding: ${pxToRem(24)};
  width: ${pxToRem(280)};
`;

export const Title = styled.h3`
  font-size: ${pxToRem(18)};
  font-weight: 600;
  margin-bottom: ${pxToRem(12)};
`;

export const TimeDisplay = styled.div`
  display: flex;
  align-items: center;
  gap: ${pxToRem(16)};
`;

export const TimeBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Text = styled.span`
  color: rgb(139, 129, 150);
  font-size: ${pxToRem(16)};
  font-weight: 500;
`;

export const Separator = styled.span`
  color: rgb(139, 129, 150);
  font-size: ${pxToRem(42)};
  font-weight: 600;
  margin-bottom: ${pxToRem(30)};
`;

export const TimeInput = styled.div`
  width: ${pxToRem(78)};
  color: rgb(0, 0, 0);
  font-size: ${pxToRem(56)};
  font-weight: 700;
  background: transparent;
  border: none;
  outline: none;
  
  &:focus {
    border-bottom: ${pxToRem(2)} solid black;
  }
`;

export const Button = styled.button`
  font-size: ${pxToRem(18)};
  color: #555;
  background: none;
  border: none;
  cursor: pointer;

  &:hover {
    color: black;
  }
`;

export const LabelRow = styled.div`
  display: flex;
  justify-content: space-between;
  color: #777;
  font-size: ${pxToRem(14)};
  width: 100%;
  padding: 0 ${pxToRem(20)};
  margin-top: ${pxToRem(8)};
`;
